<template>
  <FusionBaseDialog
    :open="open"
    @close="close"
    :persistentOverlay="true"
    data-cy="devicesUpdatedDialog"
  >
    <template v-slot:header>
      <v-card-item>
        <v-card-title data-cy="devicesUpdatedHeader">
          {{ $t('devicesUpdatedDialog.newPmSensor.title') }}
        </v-card-title>
      </v-card-item>
    </template>
    <div v-if="devicesHavingTsiPmSensor.length > 0">
      {{ $t('devicesUpdatedDialog.newPmSensor.tsiSensorMessage') }}
      <ul id="devicesHavingTsiPmSensor" data-cy="devicesHavingTsiPmSensor" class="pl-5 py-3">
        <li v-for="device in devicesHavingTsiPmSensor" :key="device.serial">
          {{ device.modelName }} "{{ device.name }}" ({{ device.serial }})
        </li>
      </ul>
    </div>
    <div v-if="devicesHavingNonTsiPmSensor.length > 0">
      {{ $t('devicesUpdatedDialog.newPmSensor.nonTsiSensorMessage') }}
      <ul id="devicesHavingNonTsiPmSensor" data-cy="devicesHavingNonTsiPmSensor" class="pl-5 py-3">
        <li v-for="device in devicesHavingNonTsiPmSensor" :key="device.serial">
          {{ device.modelName }} "{{ device.name }}" ({{ device.serial }})
        </li>
      </ul>
    </div>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <v-btn
        @click="close"
        class="bg-primary text-white"
        variant="text"
        data-cy="devicesUpdatedClose"
        >{{ $t('buttons.done') }}
      </v-btn>
    </template>
  </FusionBaseDialog>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import { NAMESPACES } from '@/store/types'
import { DEVICE_MODELS_GETTERS } from '@/store/devicemodels'
import { DeviceUpdateType, type UpdatedDevice } from '@/types/user'

interface UpdatedDeviceWithModelName extends UpdatedDevice {
  modelName: string | undefined
}

export default defineComponent({
  name: 'DevicesUpdatedDialog',
  props: {
    devices: {
      type: Array as PropType<UpdatedDevice[]>,
      required: true
    },
    open: {
      type: Boolean,
      required: true
    }
  },
  emits: ['close'],
  data() {
    return {}
  },
  computed: {
    devicesHavingTsiPmSensor(): UpdatedDeviceWithModelName[] {
      return this.devices
        .map((d: UpdatedDevice) => ({
          ...d,
          modelName: this.$store.getters[
            `${NAMESPACES.DEVICE_MODELS}/${DEVICE_MODELS_GETTERS.GET_MODEL_NAME}`
          ](d.model)
        }))
        .filter((d) => d.update === DeviceUpdateType.HasNewTSIPMSensor)
    },
    devicesHavingNonTsiPmSensor(): UpdatedDeviceWithModelName[] {
      return this.devices
        .map((d: UpdatedDevice) => ({
          ...d,
          modelName: this.$store.getters[
            `${NAMESPACES.DEVICE_MODELS}/${DEVICE_MODELS_GETTERS.GET_MODEL_NAME}`
          ](d.model)
        }))
        .filter((d) => d.update === DeviceUpdateType.HasNewNonTSIPMSensor)
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
})
</script>

<style scoped>
li {
  list-style-type: disc;
}
</style>
